// import React, { useEffect, useState } from "react";
// import { DialogBox } from "../../../../../components/Elements/DialogBox";
// import { Button, Checkbox } from "antd";
// import { getApi } from "../../../../../api/api_instance";
// import { LoaderIcon } from "react-hot-toast";
// import { API_URLS } from "../../../../../api/apiUrls";

// const AddNewDynamicForm = ({
//   onOpen,
//   onClose,
//   projectId,
//   selectedForms,
//   setSelectedForms,
//   addForms,
// }) => {
//   const [dynamicFormsList, setDynamicFormsList] = useState([]);
//   const [loadingForms, setLoadingForms] = useState({ forms: false });

//   const fetchForms = async (page=1) => {
//     try {
//       console.log("cursor is here");
//       setLoadingForms({ forms: true });
//       const response = await getApi({
//         apiUrl: `${API_URLS.GET_ALL_CUSTOMFORMS}?pageNo=${page}`,
//       });
//       if (response?.success) {
//         const formattedForms = response.data.data.map((formData) => ({
//           label: formData.title,
//           value: formData.title.toLowerCase(),
//           formId: formData._id,
//         }));
//         setDynamicFormsList(formattedForms);
//       }
//     } catch (error) {
//       console.error("Error fetching standard survey form list", error);
//     } finally {
//       setLoadingForms({ forms: false });
//     }
//   };

//   const handleCheckboxChange = (value) => {
//     setSelectedForms((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const handleSave = () => {
//     addForms({ projectId, selectedForms });
//     onClose();
//   };

//   useEffect(() => {
//     fetchForms();
//   }, []);

//   return (
//     <DialogBox open={onOpen} onCancel={onClose} width="100%" maxWidth="700px">
//       <h3 className="text-2xl font-bold px-6">Add New</h3>
//       <hr className="mt-4" />
//       {loadingForms.forms ? (
//         <div className="my-6 flex justify-center">
//           <LoaderIcon className="w-10 h-10" style={{ color: "blue" }} />
//         </div>
//       ) : (
//         dynamicFormsList.map((form, index) => (
//           <div
//             key={form.formId}
//             className="flex justify-between h-16 items-center px-6"
//           >
//             <div className="pt-4 flex gap-8">
//               <p className="text-base font-light">{index + 1}</p>
//               <p className="text-base font-light">{form.label}</p>
//             </div>
//             <Checkbox
//               checked={selectedForms.includes(form.formId)}
//               onChange={() => handleCheckboxChange(form.formId)}
//               style={{ transform: "scale(1.5)" }}
//             />
//           </div>
//         ))
//       )}
//       <div className="flex justify-center px-20 gap-10 p-5">
//         <Button
//           style={{
//             background: "#06513D",
//             height: "40px",
//             width: "150px",
//             borderRadius: "10px",
//             border: "1px solid #06513D",
//           }}
//           className="text-base font-normal text-[#fff]"
//           onClick={onClose}
//         >
//           Cancel
//         </Button>
//         <Button
//           style={{
//             background: "#06513D",
//             height: "40px",
//             width: "150px",
//             borderRadius: "10px",
//           }}
//           className="text-base text-white font-normal"
//           onClick={handleSave}
//         >
//           Save
//         </Button>
//       </div>
//     </DialogBox>
//   );
// };

// export default AddNewDynamicForm;

import React, { useCallback, useEffect, useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Button, Checkbox } from "antd";
import { getApi, postApi } from "../../../../../api/api_instance";
import { LoaderIcon } from "react-hot-toast";
import { API_URLS } from "../../../../../api/apiUrls";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const AddNewDynamicForm = ({
  onOpen,
  onClose,
  projectId,
  selectedForms,
  setSelectedForms,
  addForms,
}) => {
  const [dynamicFormsList, setDynamicFormsList] = useState([]);
  const [loadingForms, setLoadingForms] = useState({ forms: false });
  const [savingForms, setSavingForms] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [initialSelectedForms, setInitialSelectedForms] = useState([]);
  const [projectFormIds, setProjectFormIds] = useState([]); // Store project-specific form IDs

  const fetchTableData = useCallback(async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
      });
      console.log(response, "datatatat");
      if (response?.success) {
        // Extract the _id values from project forms
        const projectFormIdsArray = response.data.map((item) => item._id);
        setProjectFormIds(projectFormIdsArray);
        console.log(projectFormIdsArray, "projectFormIdsArray");
        // Set these as initially selected forms
        setInitialSelectedForms([...projectFormIdsArray]);
        setSelectedForms([...projectFormIdsArray]);

        console.log("Project Form IDs:", projectFormIdsArray);
      }
    } catch (error) {
      console.error("Error fetching standard survey forms:", error);
    }
  }, [projectId, setSelectedForms]);

  const fetchForms = async (page = 1) => {
    try {
      console.log("Fetching forms for page:", page);
      setLoadingForms({ forms: true });
      const response = await getApi({
        apiUrl: `${API_URLS.GET_ALL_CUSTOMFORMS}?pageNo=${page}`,
      });
      if (response?.success) {
        const formattedForms = response.data.data.map((formData) => ({
          label: formData.title,
          value: formData.title.toLowerCase(),
          formId: formData._id,
        }));
        setDynamicFormsList(formattedForms);

        // Set pagination info
        setTotalPages(response.data.pagination?.totalPages || 1);
        setTotalItems(
          response.data.pagination?.totalDocs || formattedForms.length,
        );
        setCurrentPage(page);

        console.log("All Forms:", formattedForms);
      }
    } catch (error) {
      console.error("Error fetching standard survey form list", error);
    } finally {
      setLoadingForms({ forms: false });
    }
  };

  const handleCheckboxChange = (value) => {
    setSelectedForms((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  };

  const handleSave = async () => {
    try {
      setSavingForms(true);

      // Get current date in YYYY-MM-DD format
      const currentDate = new Date().toISOString().split("T")[0];

      // Prepare checked forms (newly selected or already selected)
      const checkedForms = selectedForms.map((formId) => ({
        id: formId,
        date: currentDate,
      }));

      // Prepare unchecked forms (forms that were initially selected but now unselected)
      const uncheckedForms = initialSelectedForms
        .filter((formId) => !selectedForms.includes(formId))
        .map((formId) => ({ id: formId }));

      const payload = {
        custom_form: {
          checked: checkedForms,
          unchecked: uncheckedForms,
        },
      };

      console.log("Saving forms with payload:", payload);

      const response = await postApi({
        apiUrl: `api/client/project/add-dynamic-form/${projectId}`,
        data: payload,
      });

      if (response?.success) {
        console.log("Forms saved successfully");
        // Call the original addForms function if needed for UI updates
        addForms({ projectId, selectedForms });
        onClose();
      } else {
        console.error(
          "Failed to save forms:",
          response?.message || "Unknown error",
        );
      }
    } catch (error) {
      console.error("Error saving forms:", error);
    } finally {
      setSavingForms(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      fetchForms(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      fetchForms(currentPage - 1);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchForms(page);
    }
  };

  useEffect(() => {
    // First fetch project-specific forms, then fetch all forms
    const initializeData = async () => {
      await fetchTableData(); // This will set the initial selected forms
      await fetchForms(); // This will fetch all available forms
    };

    initializeData();
  }, [fetchTableData]);

  return (
    <DialogBox open={onOpen} onCancel={onClose} width="100%" maxWidth="700px">
      <h3 className="text-2xl font-bold px-6">Add New</h3>

      {/* Content Area */}
      <div className="min-h-[410px]">
        {loadingForms.forms ? (
          <div className="my-6 flex justify-center">
            <LoaderIcon className="w-10 h-10" style={{ color: "blue" }} />
          </div>
        ) : (
          <>
            {/* Forms List */}
            <div
              className="max-h-[460px] overflow-y-auto"
              style={{
                msOverflowStyle: "none",
                scrollbarWidth: "none",
                WebkitScrollbar: { display: "none" },
              }}
            >
              {dynamicFormsList.length > 0 ? (
                dynamicFormsList.map((form, index) => {
                  // Check if this form is already associated with the project
                  const isProjectForm = projectFormIds.includes(form.formId);

                  return (
                    <div
                      key={form.formId}
                      className="flex justify-between h-10 items-center px-6 hover:bg-gray-50"
                    >
                      <div className="pt-4 flex gap-8">
                        <p className="text-base font-light">
                          {(currentPage - 1) * 10 + index + 1}
                        </p>
                        <p className="text-base font-light">{form.label}</p>
                      </div>
                      <input
                        type="checkbox"
                        style={{ accentColor: "#06513D" }}
                        className="w-4 h-4"
                        checked={selectedForms.includes(form.formId)}
                        onChange={() => handleCheckboxChange(form.formId)}
                      />
                    </div>
                  );
                })
              ) : (
                <div className="text-center py-8 text-gray-500">
                  <p>No forms available</p>
                </div>
              )}
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="border-t px-6 py-3">
                <div className="flex items-center justify-between">
                  <div className="flex w-full justify-between items-center gap-4">
                    {/* Previous Button */}
                    <Button
                      onClick={handlePrevPage}
                      disabled={currentPage <= 1}
                      className="flex items-center  px-3 py-1 text-sm h-8"
                      style={{
                        border: "1px solid #d1d5db",
                        borderRadius: "6px",
                        background: currentPage <= 1 ? "#f3f4f6" : "#fff",
                        color: currentPage <= 1 ? "#9ca3af" : "#374151",
                        padding: "4px 10px",
                        width: "auto",
                      }}
                    >
                      <IoChevronBack className="w-4 h-4 mr-1" />
                      Previous
                    </Button>

                    {/* Page Numbers */}
                    <div className="flex items-center justify-center gap-2 flex-1">
                      {[...Array(totalPages)].map((_, index) => {
                        const page = index + 1;
                        const isCurrentPage = page === currentPage;

                        if (
                          page === 1 ||
                          page === totalPages ||
                          (page >= currentPage - 1 && page <= currentPage + 1)
                        ) {
                          return (
                            <Button
                              key={page}
                              onClick={() => handlePageChange(page)}
                              className="px-3 py-1 text-sm h-8"
                              style={{
                                border: "1px solid #d1d5db",
                                borderRadius: "6px",
                                background: isCurrentPage ? "#06513D" : "#fff",
                                color: isCurrentPage ? "#fff" : "#374151",
                              }}
                            >
                              {page}
                            </Button>
                          );
                        }

                        if (
                          (page === currentPage - 2 && currentPage > 3) ||
                          (page === currentPage + 2 &&
                            currentPage < totalPages - 2)
                        ) {
                          return (
                            <span key={page} className="px-2 text-gray-500">
                              ...
                            </span>
                          );
                        }

                        return null;
                      })}
                    </div>

                    {/* Next Button */}
                    <Button
                      onClick={handleNextPage}
                      disabled={currentPage >= totalPages}
                      className=" flex items-center px-4 py-1 text-sm h-8"
                      style={{
                        border: "1px solid #d1d5db",
                        borderRadius: "6px",
                        background:
                          currentPage >= totalPages ? "#f3f4f6" : "#fff",
                        color:
                          currentPage >= totalPages ? "#9ca3af" : "#374151",
                        padding: "4px 10px",
                      }}
                    >
                      Next
                      <IoChevronForward className="w-4 h-4 ml-1" />
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-center px-20 gap-10 pt-4 border-t">
        <Button
          style={{
            background: "#f3f4f6",
            height: "40px",
            width: "150px",
            borderRadius: "10px",
            border: "1px solid #d1d5db",
            color: "#374151",
          }}
          className="text-base font-normal"
          onClick={onClose}
          disabled={savingForms}
        >
          Cancel
        </Button>
        <Button
          style={{
            background: "#06513D",
            height: "40px",
            width: "150px",
            borderRadius: "10px",
            color: "white",
          }}
          className="text-base text-white font-normal"
          onClick={handleSave}
          disabled={selectedForms.length === 0 || savingForms}
        >
          {savingForms ? "Saving..." : "Save"}
        </Button>
      </div>
    </DialogBox>
  );
};

export default AddNewDynamicForm;
